export const config = {
  apiKey: 'AIzaSyCIwPE4Sa_0VY_myFj2HM5x0_0CvJIH-ts',
  authDomain: 'uk-conference-manager.firebaseapp.com',
  databaseURL: 'https://uk-conference-manager.firebaseio.com',
  projectId: 'uk-conference-manager',
  storageBucket: 'uk-conference-manager.appspot.com',
  messagingSenderId: '681533705402'
}



// WEBPACK FOOTER //
// ./src/config/firebaseConfig.js